/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SiteDto } from '../../models/site-dto';

export interface SiteGetForKiosk$Params {
  SiteId?: number;
  CityId?: number;
  IsActive?: boolean;
  HospitalNo?: string;
}

export function siteGetForKiosk(http: HttpClient, rootUrl: string, params?: SiteGetForKiosk$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SiteDto>>> {
  const rb = new RequestBuilder(rootUrl, siteGetForKiosk.PATH, 'get');
  if (params) {
    rb.query('SiteId', params.SiteId, {});
    rb.query('CityId', params.CityId, {});
    rb.query('IsActive', params.IsActive, {});
    rb.query('HospitalNo', params.HospitalNo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SiteDto>>;
    })
  );
}

siteGetForKiosk.PATH = '/v1/Site/GetForKiosk';
